import $ from 'jquery';

// IMPORT COMPONENTS
import Utils from '@core/base/scripts/utils/utils';
import A11yUtils from '@core/base/scripts/utils/a11y-utils';
import LinksTabpanels from '../links-tabpanels/links-tabpanels';

export default class LinksTabsNav {

  constructor(module) {
    this.CLASSES = {
      nav: 'links-tabs-nav',
      navItem: 'links-tabs-nav__item',
      btn: 'links-tabs-nav__btn'
    };
    this.ID = {
      tab: 'linksTabsNav'
    };
    this.module = module;
    this.$nav = null;
    this.$tab = null;
    this.$currentTable = null;
  }

  init() {
    this.isInit=true;
    this.$nav = $(`.${this.CLASSES.nav}`);
    this.$tab = $(`#${this.ID.tab}`);
    this.tabpanels = new LinksTabpanels(this.module);
    
    // #138361 a hack because sometimes the collapse didnt work
    this.collapseButton = $('.links-tabs__nav');
    this.collapseButton.off().on('click', (e) => {
      if ($(window).width() < Utils.breakpoints.lg) {
        const button = e.currentTarget.querySelectorAll("button")[0];
        button.setAttribute("aria-expanded", button.getAttribute("aria-expanded") === "true" ? "false" : "true") ;
        const list = document.getElementById(button.dataset.target.replace('#',''));
        list.classList.toggle("collapse");
      }
    });
    this.$nav.removeClass('collapse');
    setTimeout(() => {
      this.$tab.on('shown.bs.collapse', () => {
        this.$tab.find(A11yUtils.FOCUSABLES).first().focus();
      });
    }, 100);
    //
    const $btns = $('.links-tabs-nav__btn', this.module);
    if($btns && $btns.length>0){
      const $currentTable = $(`#${$btns[0].dataset.target}`);
      this.tabpanels.init();
      this.tabpanels.show($currentTable);

      $btns.off().on('click', (e) => {
        this.selectTab(e);
      });
    }
  }


  resize() {
    if (this.isInit) {
      if ($(window).width() < Utils.breakpoints.lg) {
        this.$nav.addClass('collapse');
        this.isInit = true;
      } else {
        this.$nav.removeClass('collapse');
      }
      this.tabpanels.resize();
    }
  }

  selectTab(e) {
    const $items = $(`.${this.CLASSES.navItem}`, this.module);
    const $btn = $(e.currentTarget);
    const id = $btn.data('target');
    const $parent = $btn.closest(`.${this.CLASSES.navItem}`);
    //
    $items.removeClass(`${this.CLASSES.navItem}--selected`);
    $parent.addClass(`${this.CLASSES.navItem}--selected`);
    this.tabpanels.show($(`#${id}`));
    //
    const txt = $btn.text();
    $('.links-tabs-nav-collapse__label').text(txt);
  }
}
